import { render, staticRenderFns } from "./AddCommentButton.vue?vue&type=template&id=ded1940e&scoped=true&"
import script from "./AddCommentButton.vue?vue&type=script&lang=js&"
export * from "./AddCommentButton.vue?vue&type=script&lang=js&"
import style0 from "./AddCommentButton.vue?vue&type=style&index=0&id=ded1940e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded1940e",
  null
  
)

export default component.exports